"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _excluded = ["mask", "pipe", "keepCharPositions", "inputRef"];

/** https://text-mask.github.io/text-mask/ */
var MaskedInput = function MaskedInput(_ref) {
  var mask = _ref.mask,
      pipe = _ref.pipe,
      keepCharPositions = _ref.keepCharPositions,
      inputRef = _ref.inputRef,
      other = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactTextMask["default"], (0, _extends2["default"])({}, other, {
    ref: function ref(_ref2) {
      inputRef(_ref2 ? _ref2.inputElement : null);
    },
    mask: mask,
    pipe: pipe,
    keepCharPositions: keepCharPositions,
    placeholderChar: "\u2000",
    showMask: false,
    guide: false
  }));
};

var MaskArrayType = _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(RegExp)]));

MaskedInput.propTypes = {
  mask: _propTypes["default"].oneOfType([MaskArrayType, _propTypes["default"].object]).isRequired,
  pipe: _propTypes["default"].func,
  keepCharPositions: _propTypes["default"].bool,
  inputRef: _propTypes["default"].func.isRequired
};
MaskedInput.defaultProps = {
  keepCharPositions: false
};
var _default = MaskedInput;
exports["default"] = _default;